import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class DirectoryProduct extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { product, togglePopup } = this.props;
    const {
      productInformations,
      postalAddresses,
      productImages,
      type,
      productCertificates,
    } = product;

    let { company: { businessName }} = product;
    let name = '';
    productInformations.forEach((elem) => {
      if (elem.language === 'en') {
        name = elem.name;
      }
    });
    if (name === '') {
      name = businessName;
      businessName = '';
    }

    return (
      <div className="products__item" onClick={() => togglePopup(product)}>
        <div className="products__item--image">
          <img loading="lazy" src={productImages[0].thumbnailUrl} alt={productInformations[0].name} />
        </div>
        <div className="products__item--text">
          <h1 className="title">{name}</h1>
          <p className="business">{businessName}</p>
          <div className="bottom">
            <p className="city">
              <FontAwesomeIcon icon={['fas', 'map-marker-alt']} /> {postalAddresses[0].city}
            </p>
            <p className="type">{type.includes('_') ? type.replace('_', ' ') : type}</p>
          </div>
          {productCertificates && productCertificates[0] ? (
            <img className="productCertificates" src={productCertificates[0].certificateDetails.logoUrl} />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

DirectoryProduct.propTypes = {
  product: PropTypes.shape({
    productInformations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    company: PropTypes.shape({
      businessName: PropTypes.string.isRequired,
    }).isRequired,
    postalAddresses: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    productImages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  togglePopup: PropTypes.func.isRequired,
};
